// extracted by mini-css-extract-plugin
export default {"item-wrapper":"styles_item-wrapper__5UANX","item":"styles_item__eE3s0"};